export const getUuid = (state) => state.client.user.data[2]
export const getLoggedInEmail = (state) => state.client.user.data[1]
export const getContactName = (state) => state.client.user.data[3]
export const getCompanyName = (state) =>
  state.companyProfile.userData.company_name
